import React from 'react';

// Stroke-based "activity" pulse — a single clean line, so it colours with the
// sidebar's white icon treatment. The old version used fill + opacity which
// rendered faded/grey. Used by both Time Tracker and the Activity page.
const Activity = () => {
  return (
    <div className="sidebar-icon">
      <svg
        className="sidebar-icon"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22 12H18L15 21L9 3L6 12H2"
          style={{ strokeWidth: '1.5', strokeLinecap: 'round', strokeLinejoin: 'round' }}
        />
      </svg>
    </div>
  );
};

export default Activity;
